import React, { useState, createContext, useContext } from 'react';

export const FocusTrapContext = createContext({});

export const FocusTrapProvider = ({ children }) => {
  const [focusTraps, setFocusTraps] = useState({});

  const registerFocusTrap = (id) => {
    setFocusTraps((prev) => ({ ...prev, [id]: true }));

    return () => {
      setFocusTraps((prev) => ({ ...prev, [id]: false }));
    };
  };

  const reactivateFocusTrap = (id) => {
    setFocusTraps((prev) => ({ ...prev, [id]: false }));

    setTimeout(() => {
      setFocusTraps((prev) => ({ ...prev, [id]: true }));
    }, 0);
  };

  return <FocusTrapContext.Provider value={{ registerFocusTrap, reactivateFocusTrap, focusTraps }}>{children}</FocusTrapContext.Provider>;
};

export const useFocusTrapContext = () => {
  return useContext(FocusTrapContext);
};

export const withFocusTrapContext = (Component) => {
  return (props) => {
    return (
      <FocusTrapContext.Consumer>
        {({ registerFocusTrap, reactivateFocusTrap, focusTraps = {} }) => (
          <Component
            {...props}
            registerFocusTrap={registerFocusTrap}
            reactivateFocusTrap={reactivateFocusTrap}
            isActive={focusTraps[props.id]}
          />
        )}
      </FocusTrapContext.Consumer>
    );
  };
};
